export class ChatRequestModel {
  userQuestion: string;
  chatHistory: ChatInteraction[] = [];
  environment: string;
}

export interface ChatInteraction {
  inputs: string;
  outputs: string;
}
